import Vue from "vue";
import noty from "./noty.service";

export default {
  async getOperationsAwaitingAntiFraudAsync({ clientId }) {
    return (await Vue.http.get(`/api/clients/${clientId}/payment-system/operations/awaiting-antifraud`)).data;
  },
  async applyAntiFraudActionAsync({ clientId, operationId, action, setDefault }) {
    const result = (await Vue.http.post(`/api/clients/${clientId}/payment-system/operations/awaiting-antifraud/${operationId}/${action}?setDefault=${setDefault}`)).data;
    result.isSuccess ? noty.success(`${action} was successfull`) : noty.error(`Error occurred during ${action}`);
    return result;
  }
};



// WEBPACK FOOTER //
// ./src/services/paymentSystem.service.js